// src/components/Tutorial/Examples/SubscriptionsList.js
import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  Avatar,
  Stack,
  Chip,
  alpha,
  useTheme
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const SubscriptionsList = () => {
  const theme = useTheme();
  const subscriptions = [
    { name: 'Sierra', username: 'sierra', reviewed: true, avatar: null },
    { name: 'Sophie Rain', username: 'sophierain', reviewed: false, avatar: null }
  ];

  return (
    <Box className="example-container" sx={{ mt: 3 }}>
      <Card sx={{ 
        borderRadius: 4,
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        maxWidth: 600,
        mx: 'auto',
      }}>
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
            color: 'white',
            px: 3,
            py: 3,
            borderRadius: '16px 16px 0 0',
          }}
        >
          <Typography variant="h5" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            ✨ Your Subscriptions
          </Typography>
          
          {/* Stats chips */}
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
            <Chip
              label="2 Total"
              size="small"
              sx={{
                bgcolor: alpha('#fff', 0.2),
                color: 'white',
                fontWeight: 600,
                backdropFilter: 'blur(10px)',
              }}
            />
            <Chip
              label="1 Reviewed"
              size="small"
              icon={<CheckCircleIcon sx={{ color: 'white !important' }} />}
              sx={{
                bgcolor: alpha('#4caf50', 0.3),
                color: 'white',
                fontWeight: 600,
                backdropFilter: 'blur(10px)',
              }}
            />
            <Chip
              label="1 Pending"
              size="small"
              sx={{
                bgcolor: alpha('#ff9800', 0.3),
                color: 'white',
                fontWeight: 600,
                backdropFilter: 'blur(10px)',
              }}
            />
          </Box>
        </Box>

        {/* Content */}
        <CardContent sx={{ p: 0 }}>
          <Stack spacing={0}>
            {subscriptions.map((sub, i) => (
              <Box
                key={i}
                sx={{
                  px: 3,
                  py: 2.5,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  borderBottom: i < subscriptions.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    bgcolor: alpha(theme.palette.primary.main, 0.03),
                  },
                }}
              >
                <Avatar
                  sx={{
                    width: 56,
                    height: 56,
                    border: `3px solid ${alpha(theme.palette.primary.main, 0.15)}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.1)}`,
                  }}
                >
                  {sub.name?.[0]?.toUpperCase() || '?'}
                </Avatar>
                
                <Box flex={1}>
                  <Typography variant="h6" fontWeight={700} sx={{ fontSize: '1rem', mb: 0.25 }}>
                    {sub.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                    @{sub.username}
                  </Typography>
                </Box>
                
                {!sub.reviewed ? (
                  <Button
                    variant="contained"
                    sx={{
                      minWidth: 100,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 3,
                      background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
                      '&:hover': {
                        boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                        transform: 'translateY(-1px)',
                      },
                    }}
                  >
                    Review
                  </Button>
                ) : (
                  <Chip
                    icon={<CheckCircleIcon />}
                    label="Reviewed"
                    color="success"
                    sx={{
                      fontWeight: 600,
                      bgcolor: alpha(theme.palette.success.main, 0.1),
                      color: theme.palette.success.dark,
                      border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                    }}
                  />
                )}
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SubscriptionsList;
